import React from 'react';
import PropertyListItem from '../PropertyCard/PropertyListItem';
import styles from './Explore.scss';

export const NoData = ({type}) => (
  <div className={'mb-5 ' + styles.noData}>No {type} data found.</div>
);

export const SchoolList = ({data, clickHandler, isSuburbProfile}) => (
  data && data.length ?
    (data.map((school, index) =>
      <div className={'d-flex flex-column justify-content-center ' + styles.schoolRow} key={index} onClick={() => clickHandler(school)} style={{backgroundImage:'url(/assets/images/schools/'+ school.schoolType.toLowerCase() +'_3@2x.png)'}}>
        <div className="d-flex justify-content-between">
          <div className="bold600">{school.schoolName}</div>
          {!isSuburbProfile && <div>{school.distanceFromTarget}km</div>}
        </div>
        <div>{school.schoolAddress && school.schoolAddress !== 'null' ? school.schoolAddress : 'Address not found'}</div>
        <div>
          {(school.targetInShape && !isSuburbProfile) && <span className={styles['attr-InCatchment']}>IN CATCHMENT</span>}
          <span className={styles['attr-' + school.schoolType]}>{school.schoolType}</span>
          <span className={styles['attr-Sector']}>{school.schoolSector}</span>
          {school.hasOwnProperty('schoolYearLow') && school.schoolYearHigh ? <span className={styles['attr-Years']}>{school.schoolYearLow === 0 ? 'P' : school.schoolYearLow} - {school.schoolYearHigh}</span> : null}
          <span className={styles['attr-Gender']}>{school.schoolGender === 'M' ? 'Male' : school.schoolGender === 'F' ? 'Female' : 'Combined'}</span>
          <span className={styles['attr-Enrolments']}>{school.schoolEnrolments} Enrolled</span>
        </div>
      </div>
    ))
    :
    <NoData type="school" />
);

export const ComparableList = ({data, clickHandler, filter}) => {
  return (data && data.length ?
    (data.map((house, index) =>
      <div key={index} className={'d-flex flex-column justify-content-center ' + styles.houseRow} onClick={() => clickHandler(house)}>
        <PropertyListItem property={house} view={filter} />
      </div>
    ))
    :
    <NoData type="comparable" />
  );
};

export const ExploreList = ({data, clickHandler}) => {
  return (data && data.length ?
    (data.map((exp, index) =>
      <div key={index} className={'d-flex justify-content-between align-items-center ' + styles.exploreRow} onClick={() => clickHandler(exp)}>
        <div><span className="bold600">{exp.name}</span><br/>{exp.vicinity}</div>
        <div className={styles.exploreIcon}><img src={exp.icon} /></div>
      </div>
    ))
    :
    <NoData type="explore" />
  );
};

